export enum DateRange {
  TODAY = "Today",
  YESTERDAY = "Yesterday",
  LAST_7_DAYS = "Last 7 Days",
  LAST_28_DAYS = "Last 28 Days",
  LAST_90_DAYS = "Last 90 Days",
  LAST_365_DAYS = "Last 365 Days",
  ALL_TIME = "All Time",
  THIS_MONTH = "This Month",
  LAST_MONTH = "Last Month",
  LAST_3_MONTHS = "Last 3 Months",
  LAST_6_MONTHS = "Last 6 Months",
  LAST_YEAR = "Last Year"
}

export enum DateBucketEnum {
  DAY = "day",
  WEEK = "week",
  MONTH = "month",
  QUARTER = "quarter",
  YEAR = "year"
}
